

const FormLabel = ({label, isRequired=true, className, trailing}) => {
  return <label className={`${className ? `${className} ` : ""}text-sm font-medium block mb-2 flex justify-between items-center`}>
    <span>{label} {isRequired ? "" : <i className="font-normal">(Optional)</i>}</span>
    {trailing}
  </label>
}


export default FormLabel